"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.trackLog.goToSource': 'Ir al origen',
    'whatsapp.trackLog.status.neutral': 'Neutro',
    'whatsapp.trackLog.status.good': 'Bueno',
    'whatsapp.trackLog.status.warning': 'Advertencia',
    'whatsapp.trackLog.status.critical': 'Crítico',
    'whatsapp.trackLog.type': 'Tipo:',
};
